import { useEffect, useState } from 'react';
export function useAuditSummary(params = {}) {
	const [data, setData] = useState(null);
	useEffect(() => {
		const url = new URL(`${import.meta.env.VITE_APP_API_URL}/audit/summary`, window.location.origin);
		Object.entries(params).forEach(([k, v]) => v && url.searchParams.set(k, String(v)));
		fetch(url.toString())
			.then(r => r.json())
			.then(setData);
	}, [JSON.stringify(params)]);
	return data;
}
